jQuery(function () {
    let safe_pages = '.page-id-14238', // jobs-landing
        targets = jQuery(safe_pages);

    jQuery('.page-id-14238 [style]').attr('style', '');
});